/**
 * ThingsBoard REST API
 * For instructions how to authorize requests please visit <a href=\'http://thingsboard.io/docs/reference/rest-api/\'>REST API documentation page</a>.
 *
 * The version of the OpenAPI document: 2.0
 * Contact: info@thingsboard.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AlarmId } from './alarmId';
import { EntityId } from './entityId';
import { TsValue } from './tsValue';
import { TenantId } from './tenantId';


export interface AlarmData { 
    ackTs?: number;
    clearTs?: number;
    createdTime?: number;
    details?: string;
    endTs?: number;
    entityId?: EntityId;
    id?: AlarmId;
    latest?: { [key: string]: { [key: string]: TsValue; }; };
    name?: string;
    originator?: EntityId;
    originatorName?: string;
    propagate?: boolean;
    propagateRelationTypes?: Array<string>;
    severity?: AlarmData.SeverityEnum;
    startTs?: number;
    status?: AlarmData.StatusEnum;
    tenantId?: TenantId;
    type?: string;
}
export namespace AlarmData {
    export type SeverityEnum = 'CRITICAL' | 'MAJOR' | 'MINOR' | 'WARNING' | 'INDETERMINATE';
    export const SeverityEnum = {
        CRITICAL: 'CRITICAL' as SeverityEnum,
        MAJOR: 'MAJOR' as SeverityEnum,
        MINOR: 'MINOR' as SeverityEnum,
        WARNING: 'WARNING' as SeverityEnum,
        INDETERMINATE: 'INDETERMINATE' as SeverityEnum
    };
    export type StatusEnum = 'ACTIVE_UNACK' | 'ACTIVE_ACK' | 'CLEARED_UNACK' | 'CLEARED_ACK';
    export const StatusEnum = {
        ACTIVEUNACK: 'ACTIVE_UNACK' as StatusEnum,
        ACTIVEACK: 'ACTIVE_ACK' as StatusEnum,
        CLEAREDUNACK: 'CLEARED_UNACK' as StatusEnum,
        CLEAREDACK: 'CLEARED_ACK' as StatusEnum
    };
}


